var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwentyfour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    role: "presentation",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.1 86.8c0-8-5.7-16.7-18.1-16.7-10.3 0-15.4 8-15.5 8.2-.9 1.3-.8 3 .5 4.3l1 .8c1.4 1 3.2.8 4.3-.5l.4-.4c1.2-1.4 4.1-4.8 9.2-4.8 7.1 0 10.2 4.6 10.2 9.2 0 3.8-2.3 7.9-7.6 13.1l-20.2 20.3v2.2c0 1.7 1.4 3.1 3.1 3.1h29c1.7 0 3.1-1.4 3.1-3.1v-1.1c0-1.7-1.4-3.1-3.1-3.1H74l13.1-13.1c5-5.1 10-10.6 10-18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2 124.7c.8.8 2 .9 3 .9h.7c1.7 0 3.1-1.4 3.1-3.1V114h3.4c1.7 0 3.1-1.4 3.1-3.1v-1c0-1.7-1.4-3.1-3.1-3.1H134V73c0-1.8-1.2-3-3-3h-2.4l-31.4 38.6v2c0 1.9 1.4 3.3 3.4 3.3h25.7v8.4c0 1 .3 1.8.9 2.4zM108 106.8l18.4-22.5v22.5H108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.7 95.7c-2.4 0-4.3 1.9-4.3 4.3 0 50.3-41 91.3-91.3 91.3S8.8 150.3 8.8 100 49.7 8.7 100 8.7c30.9 0 59.2 15.3 76.2 41l-17.7.4c-2.4.1-4.3 2-4.2 4.4.1 2.4 2 4.3 4.4 4.2l28.7-.7c.9 0 1.8-.3 2.4-.8.9-.7 1.6-1.7 1.8-2.9l4.3-28.4c.4-2.4-1.3-4.6-3.7-4.9-2.4-.4-4.6 1.3-4.9 3.7l-3.2 21.1C165.5 17.1 134.2 0 100 0 44.9 0 0 44.9 0 100s44.9 100 100 100 100-44.9 100-100c0-2.4-1.9-4.3-4.3-4.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentyfour);
export default __webpack_public_path__ + "static/media/twentyfour.07af6d7c.svg";
export { ForwardRef as ReactComponent };